import React from 'react'
import { useTranslation } from 'react-i18next'

import NotFoundBannerImage from '@/assets/404_error.svg'
import styled, { css } from '@/styles'

import { ErrorPageBase } from '../ErrorPageBase'

const StyledErrorPageBase = styled(ErrorPageBase)<{ limitedWidth?: boolean }>`
	flex-direction: column-reverse;

	${({ limitedWidth: $limitedWidth }) =>
		$limitedWidth
			? css`
					max-width: 1024px;
					margin: 0 auto;
				`
			: ''}
`

interface NotFoundBannerProps {
	limitedWidth?: boolean
}

export function NotFoundBanner({ limitedWidth }: NotFoundBannerProps) {
	const { t } = useTranslation()
	return (
		<StyledErrorPageBase
			limitedWidth={limitedWidth}
			data-test="NotFoundBanner"
			title={t('not-found-banner-title')}
			subtitle={t('not-found-banner-subtitle')}
			pictureProps={{ defaultSrc: NotFoundBannerImage, width: '100%' }}
		/>
	)
}
